import { useQuery } from "@tanstack/react-query";
import useAxiosPrivate from "./useAxiosPrivate";
import CategoryTrackMappingAPIs from "../apiRoutes/CategoryTrackMapping";
import { GET_CTM_OPTIONS_QUERY_KEY } from "../utils/constants/queryKeys";

/** Sorted CTM categories for one app x language. */
export default function useCtmCategories(
  { app, language },
  { enabled = true } = {}
) {
  const axiosPrivate = useAxiosPrivate();
  const { data } = useQuery({
    queryKey: [...GET_CTM_OPTIONS_QUERY_KEY, app, language],
    queryFn: () =>
      CategoryTrackMappingAPIs.options({
        axiosPrivate,
        app_name: app,
        language,
      }),
    enabled: enabled && !!app && !!language,
  });
  const names = (data?.categories ?? []).filter((c) => c && c.trim());
  return [...new Set(names)].sort((a, b) => a.localeCompare(b));
}
